export default {
    title: "Ordine per conto di",
    model: {
        email: {
            label: "E-mail",
            placeholder: "Si prega di compilare il nome utente o l'email",
            notFound: "Utenti non trovati",
            errors: {
                myself: "L'email deve essere diversa dalla tua"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Invia",
            processing: "Invio"
        }
    },
    error: {
        userNotExists: "{email} non esiste",
        country: {
            default: "Al momento OI non è disponibile nel paese dell'utente",
            ALPHA3: ""
        }
    }
}